import gql from 'graphql-tag'

export const entitiesAllFields = gql`
  query EntitiesAllFields($accountId: Int!, $token: String) {
    entitiesAllFields(accountId: $accountId, token: $token) {
      fields
      entities
    }
  }
`
